const vehicleReport = {
  title: 'Informe de Viaje del Vehículo',
  description: 'Proporciona información estadística sobre la actividad de conductores individuales.',
  table: {
    headers: {
      id: 'ID',
      driver: 'Conductor',
      supplier: 'Proveedor',
      vehicle: 'Vehículo',
      zones: 'Zonas',
      locations: 'Ubicaciones',
      profiles: 'Perfiles',
      attributes: 'Atributos',
      trips: 'Viajes',
      driverShifts: 'TURNO',
      departureTime: 'SCHEDULED DEPARTURE',
      start: 'Início',
      end: 'Fin',
      hours: 'Horas',
      booking: 'Reservación',
      tripDuration: 'Duración del Viaje',
      tripDistance: 'Distancia del Viaje',
      distanceToPickUp: 'Distancia para Recoger',
      totalDistance: 'Distancia total',
      loadedDistance: 'Distancia con Pasajero',
      earningPerHour: 'Ganancia por Hora',
      amount: 'Cantidad',
      cost: 'Costo',
    },
    driver: 'Conductor',
    Amount: 'Cantidad',
    unassignedTrips: 'No Asignado',
    yes: 'SÍ',
    no: 'NO',
  },

  filter: {
    export: 'Exportar',
    driver: 'Conductor',
    supplier: 'Proveedor',
    car: 'Vehículo',
    zones: 'Zonas',
    locations: 'Ubicaciones',
    airportLocations: 'Ubicaciones de Aeropuerto',
    profiles: 'Perfiles',
    attributes: 'Atributos',
    submit: 'Filtrar',
    clear: 'Borrar filtro',
    driverShifts: {
      title: 'Turnos de Conductores',
      options: {
        withShifts: 'Con Turno',
        withoutShifts: 'Sin Turno',
      },
    },
    validation: {
      startDateRequired: 'La fecha de inicio es obligatoria',
      endDateRequired: 'La fecha de finalización es obligatoria',
    },
  },

  vehicleSummary: {
    total: 'Vehículos',
    totalTrips: 'Viajes',
    totalReservation: 'Reservaciones',
    loadedDistance: 'Distancia cargada',
    totalCost: 'Costo Total',
  },

  form: {
    dateEnd: 'Fecha de finalización',
    dateStart: 'Fecha de inicio',
  },
  export: 'Informe de Vehículo',
};

export default vehicleReport;
